import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import PlayerFetched from "../views/PlayerFetched.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: Home
  },
  {
    path: "/:nickname",
    name: "player",
    component: PlayerFetched
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
